export default __webpack_public_path__ + "static/media/03AW2FEB66.06358974.jpg";